import getContentUrl from "utils-lib/getContentUrl"
import { withLocalization } from "hoc-lib/localization"
import { isTeamsitePage } from "utils-lib/isTeamsitePage"
import { getWindow } from "utils-lib/getWindow"
import { isMyWMApp } from "utils-lib/isMyWMApp/index"
import SocialMediaLinks from "../FooterLegal/SocialMediaLinks/SocialMediaLinks"
import QuickLinks from "./QuickLinks/QuickLinks"
import { Link } from "../../../Base"
import "./FooterContent.scss"

const strings = {
  en_CA: {
    SR_LOGO_TEXT: `Waste Management Home`,
  },

  fr_CA: {
    SR_LOGO_TEXT: `Waste Management Résidence`,
  },
}

const FooterContent = ({
  columns,
  logo,
  logoAltText = "",
  logolink,
  socialMediaLinks,
  strings,
  hasMasterBillType = false,
}) => {
  const ssrWindow = getWindow()

  const isExternalLink =
    isMyWMApp || isTeamsitePage(ssrWindow.location.pathname)

  return (
    <>
      <div
        className="wm-footer-logo border-bottom-white pb-3 mb-4 d-flex justify-content-between align-items-center"
        data-testid="FooterContent"
      >
        <Link href={logolink} isExternalLink={isExternalLink}>
          <span className="sr-only" data-testid="logo-text">
            {strings.SR_LOGO_TEXT}
          </span>
          <img
            className="footer-logo"
            src={getContentUrl(logo)}
            alt={logoAltText}
            width="107px"
            height="44px"
          />
        </Link>
      </div>
      <div className="FooterContent">
        <div className="footer-main-wrapper d-flex">
          <QuickLinks hidePayMyBill={hasMasterBillType} columns={columns} />
        </div>
      </div>
      <div className="d-md-flex d-block socialLinks">
        <SocialMediaLinks links={socialMediaLinks} />
      </div>
    </>
  )
}

// // Note: React 19 no-longer supports propTypes. Leaving this until we can remove the legacy component.
// FooterContentLegacy.propTypes = {
//   columns: PropTypes.array.isRequired,
//   logo: PropTypes.string.isRequired,
//   logolink: PropTypes.string.isRequired,
//   logoAltText: PropTypes.string.isRequired,
//   quickLinks: PropTypes.array,
//   socialMediaLinks: PropTypes.array.isRequired,
//   text: PropTypes.string,
//   strings: PropTypes.object.isRequired,
//   showFooter: PropTypes.bool,
//   setShowFooter: PropTypes.func,
//   hasMasterBillType: PropTypes.bool,
// }

// // Note: React 19 no-longer supports defaultProps. Leaving this until we can remove the legacy component.
// FooterContentLegacy.defaultProps = {
//   showFooter: false,
//   setShowFooter: noop,
//   hasMasterBillType: false,
//   quickLinks: [],
//   text: ``,
// }

export default withLocalization(strings)(FooterContent)
